import { Home } from 'lucide-react';
import {
  ApplicationStepContent,
  StepHeader,
  StepActions,
  StepActionButton,
} from '../ApplicationStepComponents';

interface ApplicationCompleteStepProps {
  onGoHome: () => void;
}

export function ApplicationCompleteStep({ onGoHome }: ApplicationCompleteStepProps) {
  return (
    <ApplicationStepContent>
      <StepHeader
        icon={
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
            <svg
              className="h-8 w-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        }
        title="Application Complete"
        description="Your policy application has been successfully submitted and is now being processed."
      />

      <StepActions>
        <StepActionButton
          onClick={onGoHome}
          icon={<></>}
        >
          <Home className="mr-2 h-4 w-4" />
          Return to Dashboard
        </StepActionButton>
      </StepActions>
    </ApplicationStepContent>
  );
}